module.exports = __webpack_public_path__ + "2d3bec44f070a4291ca410647d0e2c08.svg";